import { ModalStore } from '../state/ModalStore'
import '../styles/globals.css'
import '../styles/calendor.css'
import '../styles/wordpress.css'
import NextNProgress from 'nextjs-progressbar'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { Fragment, useEffect, useState } from 'react'
import { AffiliateWP } from '../helpers/Affiliate'
import { useRouter } from 'next/router'
import { handleTurboLetters, handleMaybeRedirect } from '../helpers/utils'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import HeaderContext from '../context/HeaderContext'
import HeaderTopLevel from '../components/HeaderTopLevel'
import { LoadingProvider } from '../context/LoadingProvider'
import LoadingPlaceHolder from '../context/LoadingPlaceHolder'
import Maintenance from '../components/Maintenance'

const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_KEY)

const CaptchaWrapper = ({ children, pageProps }) => {
    if (pageProps?.isComponent) {
        return children
    }

    if (process.env.NEXT_PUBLIC_MAINTENANCE_MODE === '1') {
        return <Maintenance />
    }

    return (
        <GoogleReCaptchaProvider
            reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_KEY}
            scriptProps={{
                async: false,
                defer: false,
                appendTo: 'head',
                nonce: undefined,
            }}
            container={{
                element: 'captcha-container',
                parameters: {
                    badge: 'bottomleft',
                },
            }}>
            {children}
        </GoogleReCaptchaProvider>
    )
}

function MyApp({ Component, pageProps }) {
    const modals = ModalStore((state) => state.modals)
    const router = useRouter()

    // log('router', Component, pageProps)

    const [headerData, setHeaderData] = useState(null)

    useEffect(() => {
        AffiliateWP.init(router)
        handleTurboLetters(router)
        handleMaybeRedirect(router)
    }, [router])

    // const handleHubspot = () => {
    //     window?.HubSpotConversations.on('conversationStarted', () => {
    //         window?.gtag('event', 'conversationStarted', {
    //             event_category: 'Hubspot',
    //             event_label: 'chatInitiated',
    //         })
    //     })
    // }

    // useEffect(() => {
    //     if (window) {
    //         window.addEventListener('load', handleHubspot)
    //     }
    //     return () => window.removeEventListener('load', handleHubspot)
    // }, [])

    return (
        <>
            <CaptchaWrapper pageProps={pageProps}>
                <NextNProgress />
                <Elements stripe={stripePromise}>
                    <LoadingProvider>
                        <LoadingPlaceHolder />
                        <HeaderContext.Provider
                            value={{ headerData, setHeaderData }}>
                            {!pageProps?.isComponent &&
                                !pageProps?.hideGlobalHeader && (
                                    <HeaderTopLevel
                                        {...headerData}
                                        hideNavigation={pageProps?.hideTopNav}
                                        hideCartButton={
                                            pageProps?.hideCartButton
                                        }
                                        hideLoginButton={
                                            pageProps?.hideLoginButton
                                        }
                                        hideTitle={pageProps?.hideTitle}
                                        phoneNumber={pageProps?.phoneNumber}
                                        disableLogoLink={
                                            pageProps?.disableHeaderLogoLink
                                        }
                                        bookCallCtaLabel={
                                            pageProps?.bookCallCtaLabel
                                        }
                                        bookCallModalProps={
                                            pageProps?.bookCallModalProps
                                        }
                                    />
                                )}
                            <Component {...pageProps} />
                        </HeaderContext.Provider>
                    </LoadingProvider>
                </Elements>
                {modals.length > 0 &&
                    [...modals]
                        .reverse()
                        .map((modal, index) => (
                            <Fragment key={index}>{modal}</Fragment>
                        ))}
            </CaptchaWrapper>
            <div id="captcha-container"></div>
        </>
    )
}

export default MyApp
